import React from "react"

const Timevalue = (props) => {
  const data = [
    {
      title: "Total Hours Worked",
      time: `${props.totalDuration}`,
    },
    {
      title: "Active",
      time: `${props.activeDuration}`,
    },
    {
      title: "Idle",
      time: `${props.idleDuration}`,
    },
    {
      title: "Evaluation",
      time: `${props.evaluationDuration}`,
    },
  ]
  return (
    <div
      className="d-flex pb-2"
      style={{
        flexFlow: "row wrap",
        justifyContent: "start",
        alignContent: "space-around",
      }}
    >
      {data.map((item, index) => (
        <div className="d-flex" key={index} style={{ paddingRight: "1rem" }}>
          <div className="font-weight-bold">{item?.title}:</div>
          <div className="font-weight-normal" style={{ paddingLeft: "5px" }}>
            {item?.time}
          </div>
        </div>
      ))}
    </div>
  )
}
export default Timevalue
